import { useEffect, useState } from "react";
import { UserAddress } from "@shared/types/UserAccountTypes.interface";
import { SvgIcon } from "@shared/components/Atoms/SvgIcon/SvgIcon";
import { IconNames } from "@shared/enums/icons.enums";
import S from "./AddressCard.module.scss";
import Button from "@shared/components/Atoms/Button/Button";
import { useTranslations } from "@shared/context/useTranslations";
import { countryFromCode } from "@shared/helpers/countryHelper";
import { cn } from "@shared/helpers/classNames.helper";

interface AddressCardProps {
    address: UserAddress;
    isSelected?: boolean;
    onSelect: (addressId: string) => void;
}

export const AddressCard = ({ address, isSelected, onSelect }: AddressCardProps) => {
    const { getTranslation } = useTranslations();
    const [iconKey, setIconKey] = useState(0);

    useEffect(() => {
        setIconKey((prevKey) => prevKey + 1);
    }, [isSelected]);

    return (
        <div
            className={cn(S.addressCard, isSelected && S.selected)}
            onClick={() => onSelect(address.id!)}
        >
            <div className={S.addressInfo}>
                <h4>{address.alias}</h4>
                {address.streetName}
                <div className={S.addressInfoSmall}>
                    {address.postalCode}&nbsp;
                    {address.cityName}
                    <br />
                    {countryFromCode(address.countryId)} ({address.countryId})
                </div>
            </div>

            {isSelected ? (
                <div className={S.selectedBox}>
                    <SvgIcon
                        key={iconKey} // Force icon re-render via key update due to Safari SVG issue
                        iconName={IconNames.Checkmark}
                    />
                    {getTranslation("AddressCard.selected")}
                </div>
            ) : (
                <Button onClick={() => onSelect(address.id!)}>
                    {getTranslation("AddressCard.select")}
                </Button>
            )}
        </div>
    );
};
